export default __webpack_public_path__ + "static/media/pdf.333cfcd5.png";